import { Injectable } from '@angular/core';
import { UserService } from '@app/shared/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as loginActions from './actions';

@Injectable()
export class LoginStoreEffects {
  constructor(private userService: UserService, private actions$: Actions, private store$: Store<RootStoreState.State>) {}

  loginObject = this.store$.select('User');

  loginRequestEffect$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<loginActions.LoginRequestAction>(loginActions.ActionTypes.LOGIN_REQUEST),
      switchMap((action: any) => {
        return this.userService.getUser().pipe(
          map((data) => {
            return new loginActions.LoginSuccessAction(data);
          }),
          catchError((error) => {
            return of(new loginActions.LoginFailureAction(error));
          })
        );
      })
    )
  );

  loginRequestEffectWithPremium$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<loginActions.LoginRequestActionPremium>(loginActions.ActionTypes.LOGIN_REQUEST_PREMIUM),
      switchMap((action: any) => {
        return this.userService.getUser().pipe(
          map((data) => {
            data['premium_status'] = 'subscribed';
            return new loginActions.LoginSuccessActionPremium(data);
          }),
          catchError((error) => {
            return of(new loginActions.LoginFailureActionPremium(error));
          })
        );
      })
    )
  );
}
